import React from "react";
import Config from "../../config";
import {ExternalLink, Link} from "../controls/";
import Images from "../../images";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import "./Menu.scss";
import {faShoppingCart, faHeart, faSearch} from "@fortawesome/free-solid-svg-icons";

const links = [
  Config.links.howItWorks,
  Config.links.events,
  Config.links.reports,
  Config.links.ideas,
  Config.links.about,
  Config.links.contact,
  Config.links.partners,
  Config.links.b2b,
  Config.links.faq
]
// the component
function Menu({open, onClose}) {
  // render
  const externalLinks = links.map((link, index) => <ExternalItem key={index} href={link.href}>{link.label}</ExternalItem>);
  return (
    <div id="v-menu" className={open ? "open" : "closed"}>
      <div id="v-menu-inner">
        <div className="close" onClick={() => onClose()}>
          <img src={Images.icons.white.close} alt="close" />
        </div>
        {externalLinks}
        <br />
        <InternalItem to="/search" icon={faSearch} iconAlt="Suche" onClose={onClose}>Katalog</InternalItem>
        <InternalItem to="/favourites" internal={true} icon={faHeart} iconAlt="Favoriten" onClose={onClose}>Deine Favoriten</InternalItem>
        <InternalItem to="/checkout" icon={faShoppingCart} iconAlt="Warenkorb" onClose={onClose}>Warenkorb</InternalItem>
        
      </div>
    </div>
  )
}

function ExternalItem({href, children}) {
  return (
    <div className="item-external">
      <ExternalLink to={href || "https://www.appentura.ch"}>{children}</ExternalLink>
    </div>
  )
}

function InternalItem({to, icon, iconAlt, children, onClose}) {
  return (
    <Link to={to}>

    <div className="item-internal" onClick={() => onClose()}>
      <div className="item-internal-icon">
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className="item-internal-text">
        {children}
      </div>
    </div>
    </Link>
  )
}

export default Menu